import { render, staticRenderFns } from "./CustomPagination.vue?vue&type=template&id=e2eda4ee&scoped=true"
import script from "./CustomPagination.vue?vue&type=script&lang=js"
export * from "./CustomPagination.vue?vue&type=script&lang=js"
import style0 from "./CustomPagination.vue?vue&type=style&index=0&id=e2eda4ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2eda4ee",
  null
  
)

export default component.exports